/* ═══════════════════════════════════════════════════════════════════════
   GA4 LP tracking (dataLayer) for generated marketing pages — v3, 2026-07-24

   Deployment: theme asset assets/aprivents.js, loaded via
   snippets/ga4-lp-tracking.liquid (mini-loader with defer + data-page-handle).
   The filename is deliberately neutral: "tracking"/"ga4" in an external
   script name would be a candidate for ad-blocker filter lists.

   Canonical source: marketing repo Templates/tracking/ — changes are made
   THERE and copied here, never developed in the theme editor.

   Attribute-driven: without data-cta/data-section/data-nav attributes in the
   page content this script is inert. lp_id = page.handle (via the loader
   tag's data-page-handle); window.__lpId is only an optional override for
   special cases — standard pages do NOT set it.
   ═══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* idempotency guard: if the loader snippet is rendered more than once (or a
     page still carries an inline copy during the rollout window) the asset can
     be included twice — bind the listeners only on the first execution so
     events are not double-counted */
  if (window.__apriventsLoaded) return;
  window.__apriventsLoaded = true;

  var dl = window.dataLayer = window.dataLayer || [];

  /* currentScript is only set during top-level execution — read it here,
     not inside callbacks */
  var PAGE_HANDLE = (document.currentScript && document.currentScript.dataset &&
                     document.currentScript.dataset.pageHandle) || '';

  /* resolved lazily at event time: a page's optional __lpId override line
     lives in the body and may not be parsed yet when this script executes */
  function lpId() {
    return window.__lpId || PAGE_HANDLE || 'unbekannt';
  }

  function push(name, params) {
    try {
      params = params || {};
      params.event = name;
      params.lp_id = lpId();
      dl.push(params);
    } catch (e) { /* tracking must never break the page */ }
  }

  function currentTier() {
    var t = document.querySelector('[data-tier][aria-pressed="true"]');
    return t ? t.getAttribute('data-tier') : '';
  }

  /* landing page view: opt-in per page. Fires ONLY when the page requests it
     (window.__lpView = true as a config line in the body, like __lpId) or
     when window.aprivents.viewLandingPage() is called. Exactly one push per
     page view. Pages without the opt-in are unaffected. */
  var lpViewSent = false;
  function fireLandingView() {
    if (lpViewSent) return;
    lpViewSent = true;
    push('view_landingpage', {
      page_path: location.pathname,
      page_title: document.title
    });
  }

  function init() {
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;

      var a = e.target.closest('a[data-cta]');
      if (a) {
        var p = {
          cta_id: a.getAttribute('data-cta'),
          cta_section: a.getAttribute('data-cta-section') || '',
          cta_text: (a.textContent || '').trim().slice(0, 90),
          link_url: a.href
        };
        var tier = currentTier();
        if (tier) p.offer_tier = tier;
        push('cta_click', p);
        return;
      }

      var n = e.target.closest('a[data-nav]');
      if (n) {
        push('nav_click', { nav_target: n.getAttribute('data-nav') });
        return;
      }

      var t = e.target.closest('[data-tier]');
      if (t) {
        /* capture phase = pre-toggle: do not count the already selected tier again */
        if (t.getAttribute('aria-pressed') === 'true') return;
        push('select_tier', { offer_tier: t.getAttribute('data-tier') });
        return;
      }

      var c = e.target.closest('a[href^="tel:"], a[href^="https://wa.me"]');
      if (c) {
        push('contact_click', {
          contact_channel: c.getAttribute('href').indexOf('tel:') === 0 ? 'phone' : 'whatsapp'
        });
      }
    }, true);

    /* section views: once per section, when it reaches the upper 60% zone */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.unobserve(en.target);
          push('section_view', { section_id: en.target.getAttribute('data-section') });
        });
      }, { rootMargin: '0px 0px -40% 0px', threshold: 0 });
      Array.prototype.forEach.call(
        document.querySelectorAll('[data-section]'),
        function (el) { io.observe(el); }
      );
    }

    /* accordion opens (capture: runs BEFORE the toggle handler) */
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('.acc-trigger') : null;
      if (!t) return;
      var item = t.closest('.acc-item');
      if (item && item.classList.contains('is-open')) return;
      var q = t.querySelector('.acc-title');
      push('faq_open', { faq_question: ((q ? q.textContent : t.textContent) || '').trim().slice(0, 90) });
    }, true);

    /* landing page view: callable for explicit triggering from page code,
       plus auto-fire when the page has set window.__lpView = true */
    window.aprivents = window.aprivents || {};
    window.aprivents.viewLandingPage = fireLandingView;
    if (window.__lpView) fireLandingView();
  }

  /* defer executes after parsing — this wrapper protects the script if it is
     ever included without defer */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();